<template>
        <l-map ref="m_map" :zoom="maps.zoom" :crs="crs" :max-bounds="maps.maxBounds" :center="maps.center" :options="maps.mapOptions" @update:center="centerUpdated" @update:zoom="zoomUpdated">
          <l-tile-layer-google v-if="maps.currentTile.includes('google')" apikey="AIzaSyDfK73wq_XD-5QKBfZwDX06W1Xdnd0bvVA" lang="ru" region="RU" :options="maps.tileLayer[maps.currentTile].layerOptions"/>
          <l-tile-layer :url="maps.tileLayer[maps.currentTile].url" :options="maps.tileLayer[maps.currentTile].layerOptions" v-else/>
          <l-control-attribution position="bottomright" :prefix="maps.tileLayer[maps.currentTile].attribution" />
          <l-geo-json v-bind:key="key" v-for="(zone, key) in maps.zones" :geojson="zone.data" :options="zone" v-if="maps.objectOptions.geozones" lazy />
          <l-feature-group ref="features">
            <l-popup>
              <h3>{{popup.name}}</h3>
              <h4 v-if="popup.desc && popup.date_tracker">{{popup.date | moment($t('medium_date_format'))}}:
                {{popup.desc}}</h4>
              <ul class="map_info_list">
                <li v-if="popup.date"><i class="far fa-calendar-alt"></i>&nbsp;{{(popup.date_tracker ?
                  popup.date_tracker : popup.date) | moment($t('date_format'))}}
                </li>
                <li><i class="fa fa-location-arrow"></i>&nbsp;{{popup.pos.lat}}, {{popup.pos.lng}}</li>
                <li><i class="fa fa-map-pin"></i>&nbsp;{{popup.address}}</li>
                <li><i class="far fa-broadcast-tower"></i>&nbsp;{{$t('devices.defined_label')}} {{popup.pos_definition ?
                  'GPS' : 'LBS'}}
                </li>
              </ul>
            </l-popup>
          </l-feature-group>
            <l-layer-group v-if="maps.objectOptions.visible && !!objects">
                <l-marker-cluster :options="clusterOptions">
                    <l-rotated-marker v-for="(fp, key) in objects" :key="key" :icon="mainIcon(fp.data.params.gpslev > 0)" :lat-lng="fp.data" @click="getAddressForObject(fp.data)" :rotationAngle="fp.data.angle">
                        <l-tooltip  :options="tooltipOptions">
                            <div @click.stop="$router.push({name: 'device', params: {id: fp.data.id}})">{{fp.text}}</div>
                        </l-tooltip>
                    </l-rotated-marker>
                </l-marker-cluster>
            </l-layer-group>
            <l-layer-group v-if="!!footprint">
                <l-marker v-if="maps.objectOptions.history_points" v-for="(fp, key) in footprint" :key="key" :lat-lng="fp" :icon="markerIcon(key+1, !!fp.params && fp.params.gpslev > 0)" @click="getAddressForMarker(fp)" />
                <l-polyline ref="l_line" :lat-lngs="footprint" :color="'red'" :fill="false" />
            </l-layer-group>
        </l-map>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { LMap, LTileLayer, LMarker, LLayerGroup, LPopup, LPolyline, LFeatureGroup, LTooltip, LIcon, LControlAttribution, LGeoJson } from 'vue2-leaflet'
import Vue2LeafletGoogleMutant from 'vue2-leaflet-googlemutant'
import {AwesomeMarkers} from '@/assets/js/leaflet/leaflet.awesome-markers'
import {latLngBounds, latLng, icon} from 'leaflet'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import Vue2LeafletRotatedMarker from 'vue2-leaflet-es6rotatedmarker'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

export default {
  name: 'MapLayer',
  data () {
    return {
      popup: {
        name: undefined,
        pos: latLng(0, 0),
        date: undefined,
        desc: '',
        address: undefined,
        pos_definition: undefined
      },
      pos: [
        {...latLng(0, 1), id: 0},
        {...latLng(0, 1), id: 1},
        {...latLng(0, 1), id: 2}
      ]
    }
  },
  components: {
    LMap,
    LTileLayer,
    LControlAttribution,
    LMarker,
    LPopup,
    LIcon,
    LPolyline,
    LLayerGroup,
    LFeatureGroup,
    LTooltip,
    LGeoJson,
    'l-tile-layer-google': Vue2LeafletGoogleMutant,
    'l-marker-cluster': Vue2LeafletMarkerCluster,
    'l-rotated-marker': Vue2LeafletRotatedMarker
  },
  computed: {
    ...mapGetters({
      maps: 'getMap',
      crs: 'getCRS',
      objects: 'getObjects',
      objTree: 'getObjectFromTree',
      tooltipOptions: 'getTooltipOptions',
      clusterOptions: 'getClusterOptions',
      tree: 'tree',
      footprint: 'getFootprint',
      fitMarker: 'getMapFitMarker',
      foot: 'getFootPoint'
    }),
    markerIcon () {
      return (number, flag) => {
        return AwesomeMarkers.icon({
          markerColor: flag ? 'darkblue' : 'red',
          icon: 'none',
          html: '<b>' + (parseInt(number) || 0) + '</b>'
        })
      }
    },
    mainIcon () {
      return (gpslev) => icon({
        iconUrl: this.maps.mainIcon[gpslev ? 'gps' : 'lbs'],
        iconSize: [30, 30],
        iconAnchor: [20, 20]
      })
    }
  },
  methods: {
    centerUpdated (center) {
      this.$ls.set('mapCenter', latLng(center.lat, center.lng))
    },
    zoomUpdated (zoom) {
      this.$ls.set('mapZoom', zoom)
    },
    ...mapActions(['getAddress', 'getObjectCurrentAddress', 'setGeoZonesData', 'getGeoZones']),
    getAddressForMarker (k) {
      this.getAddress(this.foot(k.id)).then(() => {
        this.$forceUpdate()
      }).then(() => {
        this.openPopUp({...k, name: k.name || this.tree[this.maps.currentGroup].children[this.maps.currentDevice].data.name})
      })
    },
    getAddressForObject (k) {
      this.getObjectCurrentAddress(this.objTree(k.id)).then(() => {
        this.$forceUpdate()
      }).then(() => {
        this.openPopUp(k)
      })
    },
    openPopUp (config) {
      const noDataLabel = this.$t('devices.no_data_label')
      this.popup = {
        name: config.name,
        desc: config.desc,
        date: config.date === noDataLabel ? false : config.date,
        date_tracker: config.date_tracker === noDataLabel ? false : config.date_tracker,
        pos: latLng(config.lat, config.lng),
        address: config.address,
        pos_definition: !!config.params && config.params.gpslev > 0
      }
      this.$refs.features.mapObject.openPopup(this.popup.pos)
    }
  },
  watch: {
    'footprint' (nn) {
      if (Array.isArray(nn) && nn.length) {
        this.$nextTick(() => {
          this.$refs.m_map.fitBounds(latLngBounds(nn))
        })
      }
    },
    'fitMarker' (nn) {
      if (!Array.isArray(nn) || !nn.length) {
        nn = [nn]
      }
      this.$nextTick(this.$refs.m_map.fitBounds.bind(this, latLngBounds(nn)))
    },
    'maps.objectOptions.geozones' (nn, oo) {
      // todo reject
      if (nn !== oo) {
        this.getGeoZones(nn).then(data => {
          this.$nextTick(() => {
            this.setGeoZonesData(data)
          })
        })
      }
    },
    'crs' (nn) {
      const center = this.$refs.m_map.mapObject.getCenter()
      this.$refs.m_map.mapObject.options.crs = nn
      this.$refs.m_map.mapObject.setView(center)
      this.$refs.m_map.mapObject._resetView(this.$refs.m_map.mapObject.getCenter(), this.$refs.m_map.mapObject.getZoom())
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/map/MapLayer.vue